import { render, staticRenderFns } from "./PgaFullscreenLoadingSpinner.vue?vue&type=template&id=aa08f37c&"
import script from "./PgaFullscreenLoadingSpinner.vue?vue&type=script&lang=ts&"
export * from "./PgaFullscreenLoadingSpinner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa08f37c')) {
      api.createRecord('aa08f37c', component.options)
    } else {
      api.reload('aa08f37c', component.options)
    }
    module.hot.accept("./PgaFullscreenLoadingSpinner.vue?vue&type=template&id=aa08f37c&", function () {
      api.rerender('aa08f37c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PgaFullscreenLoadingSpinner.vue"
export default component.exports